import Button from 'app/components/Button';
import Otp from 'app/components/OTP';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import TitleText from '../components/TitleText';
import { selectVerifyEmailForm } from '../redux/selector';
import { actions } from '../redux/slice';

export default function VerifyEmail() {
    const [isManual, setIsManual] = useState(false);
    const [isSucceeded, setIsSucceeded] = useState(false);
    
    const dispatch = useDispatch();
    const navigate = useNavigate();
      const [searchParams] = useSearchParams();
      const email = searchParams.get("email");
    const verifyEmailForm = useSelector(selectVerifyEmailForm);
    
    const handleSubmit = (code: string) => {
      dispatch(
        actions.verifyEmailRequest({
          code,
          callback: () => {
            dispatch(actions.clearVerifyEmailForm());
            navigate("/onboarding/create-profile");
            setIsSucceeded(true);
          },
        })
      );
    };

    const handleResend = () => {
      if (!email) return;
      dispatch(actions.resendVerificationRequest({ email }));
    };

    const hasOtpError = !!verifyEmailForm.code.error?.trim();

    return (
      <div className="flex flex-col items-center">
        <TitleText title="Check your email" />
        <form className="flex flex-col gap-[20px] w-full max-w-[390px] mb-[56px]">
          <p className="text-secondary text-md leading-[24px] text-center font-normal">
            We’ve sent a temporary login link. Please check your inbox at{" "}
            <span className="font-medium text-black">{email}</span>
          </p>
          {isManual ? (
            <Otp
              isLoading={verifyEmailForm.isLoading}
              disabled={verifyEmailForm.isLoading}
              onSubmit={handleSubmit}
              error={verifyEmailForm.code.error}
              isSuccess={isSucceeded}
              onClearError={() => dispatch(actions.resetVerifyEmailFormError())}
            />
          ) : (
            <Button
              onClick={() => setIsManual(true)}
              type="button"
              className="w-full h-[56px] border border-secondary text-secondary bg-white"
            >
              Enter code manually
            </Button>
          )}
          {isManual && hasOtpError && (
            <div className="flex justify-center">
              <button
                type="button"
                onClick={handleResend}
                disabled={verifyEmailForm.isLoading}
                className="text-center text-primary text-md leading-[24px] font-medium disabled:opacity-50"
              >
                Resend code
              </button>
            </div>
          )}
          <div className="flex justify-center">
            <Link
              to="/auth/login"
              className="text-center text-primary text-md leading-[24px] font-medium flex flex-row items-center"
            >
              Back to login
            </Link>
          </div>
        </form>
      </div>
    );
}